import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';

@Component({
  selector: 'app-detail-report-performance',
  templateUrl: './detail-report-performance.component.html',
  styleUrls: ['./detail-report-performance.component.css']
})
export class DetailReportPerformanceComponent implements OnInit {
  datax: any = {};

  constructor(
    public navParams: NavParams,
    public modalController: ModalController
  ) {
    const incomingData = this.navParams?.data?.datax;
    if (typeof incomingData === 'string') {
      try {
        this.datax = JSON.parse(incomingData);
      } catch (error) {
        this.datax = {};
      }
    } else {
      this.datax = incomingData || {};
    }
  }

  ngOnInit(): void {
  }

  batal() {
    this.modalController.dismiss();
  }

}
